import { IonAvatar, IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonChip, IonCol, IonContent, IonFab, IonFabButton, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonMenuButton, IonPage, IonRefresher, IonRefresherContent, IonRow, IonSkeletonText, IonTitle, IonToolbar, RefresherEventDetail, useIonAlert, useIonRouter, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { checkmarkCircleOutline, chevronBackOutline, closeCircleOutline, hourglassOutline, manOutline, peopleOutline, personCircleOutline, removeCircleOutline, trashOutline } from 'ionicons/icons';
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';
import { useAppContext } from '../AppProvider';

interface RouteParams {
    token: string;
}

const PartnerEdit: React.FC = () => {
    const [loading, setLoading] = useState<boolean>(true);
    const [Partner, setPartner] = useState<any>(null);
    const [partnerPhoto, setPartnerPhoto] = useState<string>('');
    const [photoLoaded, setPhotoLoaded] = useState<boolean>(false);

    const { authKey, settings, authenticateMember, setShowLoader, SWTextDarkLogo, SWFullHorizLogo, fadeInImage, showToast } = useAppContext();
    
    const [showAlert] = useIonAlert();
    const { token } = useParams<RouteParams>();
    const router = useIonRouter();

    const memberPhotoPath = '//api.besolowise.com/members/photos/files/';

    //
    // Authenticate Member
    //
    useIonViewWillEnter(() => { 
        setShowLoader(true);
        const authenticate = async () => {
            const authenticated = await authenticateMember();   
            if(!authenticated || authenticated.mt == '') router.push('/login', 'forward');
            else {
                await getPartnership(token, authenticated.mt);
                setShowLoader(false);            
            }
        };
        authenticate();
    }); 


    const getPartnership = async (pt: string, mt: string) => {
        try {
            const formData = new FormData();
            formData.append('mt', mt);
            formData.append('pt', pt);
            const response = await fetch('https://api.besolowise.com/partners/get/', {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            
            if(response.ok) {
                const obj = await response.json();
                //console.log(obj);
                if(typeof obj.token == 'string') {
                    setPartner(obj); 
                } else {
                    showToast({
                        message: 'Data Error',
                        duration: 2000,
                        color: 'danger',
                        position: 'middle'
                    });
                }
            } else {
                showToast({
                    message: 'Response Error',
                    duration: 2000,
                    color: 'danger',
                    position: 'middle'
                });
            }
        } catch(error) {
            showToast({
                message: 'Connection Error: ' + error + '. Refresh this page to try again.',
                duration: 3000,
                color: 'danger',
                position: 'middle'
            });
        }       
    };

    const partnershipUpdate = async (e: any) => {
        const target = e.target;
        const id = target.id;
        let action = '';
        if(id == 'partnerAccept') action = 'accept';
        if(id == 'partnerDecline') action = 'decline';
        const btn: any = document.getElementById(target.id);
        btn.setAttribute('disabled', '');
        const formData = new FormData();
        formData.append('action', action);
        formData.append('token', token);
        formData.append('mt', authKey.mt);

        try {
            const apiURI = 'https://api.besolowise.com/partners/update/';
            const response = await fetch(apiURI, {
                method: 'POST',
                credentials: 'include',
                body: formData
            });
            if(response.ok) {
                const obj = await response.json(); 
                if(obj.success) {
                    router.push('/account/partners', 'back');
                } else {
                    btn.removeAttribute('disabled');
                    showToast({
                        message: 'Data Error: ' + obj.message,
                        duration: 3000,
                        color: 'danger',
                    });
                }
            } else {
                btn.removeAttribute('disabled');
                showToast({
                    message: 'Response Error',
                    duration: 3000,
                    color: 'danger',
                });
            }              
        } catch(error) {
            btn.removeAttribute('disabled');
            showToast({
                message: 'Connection Error: ' + error,
                duration: 3000,
                color: 'danger',
            });
        } 
    };

    useEffect(() => {
            const config = async () => {
                setPartnerPhoto(Partner.photoUrl);  
                setLoading(false);
            }
            if (Partner) config();                    
    }, [Partner]);

    const fadeInPhoto = () => {
        setPhotoLoaded(true);
    };

    const deletePartnership = () => {
        showAlert({
            header: 'Confirm!',
            message: 'Are you sure you want to DISCONNECT from this Partner?',
            buttons: [
                { text: 'Cancel',
                  role: 'cancel',
                  cssClass: 'alert-button-cancel', 
                },
                {
                    text: 'Disconnect',
                    role: 'confirm',
                    cssClass: 'alert-button-confirm',
                    handler: async () => {
                        try {
                            const formData = new FormData();
                            formData.append('token', token);
                            formData.append('mt', authKey.mt);
                            const response = await fetch('https://api.besolowise.com/partners/delete/', {
                                method: 'POST',
                                credentials: 'include',
                                body: formData
                            });
                            if(response.ok) {
                                const obj = await response.json(); 
                                
                                if(obj.success) {
                                    router.push('/account/partners', 'back');
                                }  else {
                                    showToast({
                                        message: 'Data error',
                                        duration: 2000,
                                        color: 'danger',
                                    });
                                }
                            } else {
                                showToast({
                                    message: 'Response Error',
                                    duration: 2000,
                                    color: 'danger',
                                });
                            }
                        } catch(error) {
                            showToast({
                                message: 'Connection Error: ' + error,
                                duration: 3000,
                                color: 'danger',
                            });
                        }  
                    }
                }
            ]
        })
    };

    const statusChip = (s: string) => {
        switch(s) {
            case '0': return <IonChip color={'medium'}><IonIcon icon={hourglassOutline}></IonIcon><IonLabel>Pending</IonLabel></IonChip>
            case '1': return <IonChip color={'medium'}><IonIcon icon={hourglassOutline}></IonIcon><IonLabel>Pending</IonLabel></IonChip>
            case '2': return <IonChip color={'success'}><IonIcon icon={checkmarkCircleOutline}></IonIcon><IonLabel>Confirmed</IonLabel></IonChip>
            case '3': return <IonChip color={'danger'}><IonLabel>Error</IonLabel></IonChip>           
            default:  return <IonChip color={'warning'}><IonLabel>Unknown</IonLabel></IonChip>
        }
    };

    const handleRefresh = (event: CustomEvent<RefresherEventDetail>) => {
        setLoading(true);
        setTimeout(async () => {
            await getPartnership(token, authKey.mt);
            event.detail.complete();
            setLoading(false);
        }, 2000);
    };

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot='start'>
                        <IonButton color={'tertiary'} routerDirection='back' routerLink='/account/partners'>Partners</IonButton>
                    </IonButtons>
                    <IonTitle><IonImg className='headerTextLogo' src={settings.theme == '1' ? SWTextDarkLogo : SWFullHorizLogo}></IonImg></IonTitle>
                    <IonButtons slot='end'>
                        <IonMenuButton color={'tertiary'} />
                    </IonButtons>
                </IonToolbar>
            </IonHeader>
            <IonContent className="ion-padding account-content-bg" id='AccountContent'>

                <IonRefresher slot="fixed" onIonRefresh={handleRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>

                <IonGrid>
                    <IonRow>
                        <IonCol size='12'>
                            <h1><IonIcon className='m-hide' color={'secondary'} icon={manOutline}></IonIcon> 
                                {loading 
                                    ? <IonSkeletonText animated={true} style={{ width: '55%', margin: '0 auto' }}></IonSkeletonText>
                                    : <>{Partner.firstName} {Partner.lastName}</>
                                }
                                <br /><span>SoloWise Partner</span>
                            </h1>                            
                        </IonCol>
                    </IonRow>
                </IonGrid>

                <IonCard>
                    <IonCardContent>
                        <IonItem className='ion-padding-bottom ion-text-center ion-justify-content-center' lines='none'>
                            {loading 
                                ? (<IonAvatar><IonSkeletonText animated /></IonAvatar>)
                                : (Partner.photo === ''
                                    ? (Partner.firstName === '' && Partner.lastName === '' 
                                        ? (<IonAvatar><IonIcon icon={personCircleOutline}></IonIcon></IonAvatar>)  
                                        : (<InitialsAvatar className='initials-avatar' name={`${Partner.firstName} ${Partner.lastName}`} />))
                                    : (<IonAvatar><IonImg className={photoLoaded ? 'fade-in' : 'fade-out'} src={partnerPhoto} onIonImgDidLoad={fadeInPhoto} /></IonAvatar>)
                                )
                            }
                        </IonItem>
                        {loading 
                            ? (<h2 className='ion-text-center'><IonSkeletonText animated={true} style={{ width: '30%' }}></IonSkeletonText></h2>)
                            : (<p className='ion-text-center'>{ Partner !== null && statusChip(Partner.status)}</p>)
                        }             
                    </IonCardContent>
                </IonCard>

                <div className='ion-text-center'>
                    {!loading &&
                        ((Partner.status == '1' && Partner.received) &&
                            (<>
                                <IonButton className='ion-margin' color={'medium'} fill='outline' id='partnerDecline' onClick={partnershipUpdate}><IonIcon icon={closeCircleOutline} className='ion-margin-end'></IonIcon> Decline</IonButton>
                                <IonButton className='ion-margin' color={'secondary'} id='partnerAccept' onClick={partnershipUpdate}><IonIcon icon={checkmarkCircleOutline} className='ion-margin-end'></IonIcon> Accept</IonButton>
                                
                               </>
                              )                   
                        )
                    }
                </div>  

                { Partner != null && (Partner.received || (!Partner.received && Partner.status != '0')) &&
                    (<div className='ion-margin-top ion-text-center'>
                        <IonButton className='ion-margin delete-button-outline' color={'remove'} fill="outline" onClick={deletePartnership}><IonIcon icon={trashOutline} slot='start'></IonIcon> Remove Partner</IonButton>
                     </div>)
                }
            </IonContent>            
        </IonPage>
    );
};

export default PartnerEdit;